/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingGroupsVisitGroupIdQueryResponse, GetApiBookingGroupsVisitGroupIdPathParams, GetApiBookingGroupsVisitGroupIdQueryParams, GetApiBookingGroupsVisitGroupId403, GetApiBookingGroupsVisitGroupId404, GetApiBookingGroupsVisitGroupId500 } from "../entities/GetApiBookingGroupsVisitGroupId";

function getGetApiBookingGroupsVisitGroupIdUrl(visit_group_id: GetApiBookingGroupsVisitGroupIdPathParams["visit_group_id"]) {
  const res = { method: 'GET', url: `/api/booking-groups/${visit_group_id}` as const }
  return res
}

/**
 * @description Возвращает резерв до оплаты, подтверждённую запись после оплаты или истёкший резерв
 * @summary Получить состояние веб-брони
 * {@link /api/booking-groups/:visit_group_id}
 */
export async function getApiBookingGroupsVisitGroupId(visit_group_id: GetApiBookingGroupsVisitGroupIdPathParams["visit_group_id"], params: GetApiBookingGroupsVisitGroupIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBookingGroupsVisitGroupIdQueryResponse, ResponseErrorConfig<GetApiBookingGroupsVisitGroupId403 | GetApiBookingGroupsVisitGroupId404 | GetApiBookingGroupsVisitGroupId500>, unknown>({ method : "GET", url : getGetApiBookingGroupsVisitGroupIdUrl(visit_group_id).url.toString(), params, ... requestConfig })
  return res.data
}